import { SET_CONFETTI } from '../types/confetti'

export const setConfetti = () => {
  return {
    type: SET_CONFETTI,
    payload: null,
  }
}